import { render } from "./TableButton.vue?vue&type=template&id=671577da&scoped=true"
import script from "./TableButton.vue?vue&type=script&lang=js"
export * from "./TableButton.vue?vue&type=script&lang=js"

import "./TableButton.vue?vue&type=style&index=0&id=671577da&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-671577da"]])

export default __exports__